<template>
  <div>
    <div v-if="loading">
      <p>Cargando..</p>
    </div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('contacts')">Regresar</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        Crear Proveedor
      </h1>
     
    </div>
    <div class="flex flex-wrap">
    <div class="w-full">
      <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(1)" v-bind:class="{'text-amber-600 bg-white': openTab !== 1, 'text-black bg-amber-600': openTab === 1}">
            Datos personales
          </a>
        </li>
      </ul>
      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        
        <div class="px-4 py-5 flex-auto">
          <div class="tab-content tab-space">
            <div v-bind:class="{'hidden': openTab !== 1, 'block': openTab === 1}">
              <form @submit.prevent="store">
              <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                <select-input v-model="form.tipo_identificacion" :req="form.tipo_identificacion" :error="form.errors.tipo_identificacion" class="pr-6 pb-8 w-full lg:w-1/6" label="Tipo de Identificación" required>
                <option>Cédula</option>
                <option>Pasaporte</option>
                <option>RUC</option>
              </select-input>
          <text-input v-model="form.ruc" :error="form.errors.ruc" :req="form.ruc" class="pb-8 pr-6 w-full lg:w-1/6" label="Identificación" required/>
                 
          <text-input v-model="form.first_name" :error="form.errors.first_name" :req="form.first_name" class="pb-8 pr-6 w-full lg:w-2/6" label="Nombres" required/>
          <text-input v-model="form.last_name" :error="form.errors.last_name" :req="form.last_name" class="pb-8 pr-6 w-full lg:w-2/6" label="Apellidos" required/>
          <text-input v-model="form.email" :error="form.errors.email" :req="form.email" class="pb-8 pr-6 w-full lg:w-2/6" label="Email" required/>
          <text-input v-model="form.phone" :error="form.errors.phone" :req="form.phone" class="pb-8 pr-6 w-full lg:w-2/6" label="Teléfono" required/>
          <text-input v-model="form.address" :error="form.errors.address" :req="form.address" class="pb-8 pr-6 w-full lg:w-2/6" label="Dirección" required/>

       </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear Proveedor</loading-button>
        </div>
      </form>
            </div>
            <div v-bind:class="{'hidden': openTab !== 2, 'block': openTab === 2}">
            </div>
            <div v-bind:class="{'hidden': openTab !== 3, 'block': openTab === 3}">
            </div>
          </div>
        </div>
       
      </div>
    </div>
  </div>
  <preloader />
  </div>
  
</template>

<script>
import Layout from '@/Shared/LayoutMenu'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';


export default {
  metaInfo: { title: 'Crear Proveedor' },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    vSelect,
    DatePicker,
  },
  layout: Layout,
  props: {
    users: Array,
  },
  remember: 'form',
  data() {
    return {
      openTab: 1,
      loading: true,
      profesiones: this.users,
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        tipo_identificacion: null,
        ruc: null,
        address: null,
        email: null,
        phone: null,
      }),
    }
  },
  async mounted(){
    await this.users
    this.loading=false
  },
  methods: {
    toggleTabs: function(tabNumber){
      this.openTab = tabNumber
    },
    store() {
      
      this.form.post('/contacts')
    },
   
  },
}
</script>